import { TextureLoader, LinearFilter, RGBAFormat, SRGBColorSpace } from 'three';
import EventEmitter from '../utils/EventEmitter.js';
import Renderer from './Renderer.js';

export default class Resources extends EventEmitter {
    static instance = null;

    static getInstance() {
        if (!Resources.instance) {
            Resources.instance = new Resources();
        }
        return Resources.instance;
    }

    constructor() {
        if (Resources.instance) {
            return Resources.instance;
        }
        
        super();
        Resources.instance = this;
    
        this.items = {
            phoneAtlas: {
                name: 'phoneAtlas',
                type: 'texture',
                path: `${window.assets_url}/images/podcast-startup-hotline/phone-sprites.png`,
            },
            triangle: {
                name: 'triangle',
                type: 'texture',
                path: `${window.assets_url}/images/podcast-startup-hotline/phone-triangle.png`,
            },
            triangleBlur: {
                name: 'triangleBlur',
                type: 'texture',
                path: `${window.assets_url}/images/podcast-startup-hotline/phone-triangle-blur-1.png`,
            },
            triangleBlur2: {
                name: 'triangleBlur2',
                type: 'texture',
                path: `${window.assets_url}/images/podcast-startup-hotline/phone-triangle-blur-2.png`,
            },
            titleStartup: {
                name: 'titleStartup',
                type: 'texture',
                path: `${window.assets_url}/images/podcast-startup-hotline/title-startup.png`,
            },
            titleHotline: {
                name: 'titleHotline',
                type: 'texture',
                path: `${window.assets_url}/images/podcast-startup-hotline/title-hotline.png`,
            },
            star: {
                name: 'star',
                type: 'texture',
                path: `${window.assets_url}/images/podcast-startup-hotline/texture-star.png`,
            },
            starBig: {
                name: 'starBig',
                type: 'texture',
                path: `${window.assets_url}/images/podcast-startup-hotline/texture-star-big.png`,
            },
        };
        
        this.toLoad = Object.keys(this.items).length;
        this.loaded = 0;
        this.loaders = {};
        this.setLoaders();
        this.startLoading();
    }
    
    setLoaders() {
        this.loaders.textureLoader = new TextureLoader();
    }
    
    startLoading() {
        for (const key in this.items) {
            const item = this.items[key];
            if (item.type === 'texture') {
                this.loaders.textureLoader.load(item.path, (file) => this.onLoad(item, file));
            }
        }
    }
    
    onLoad(item, file) {
        if (item.type === 'texture') {
            file.colorSpace = SRGBColorSpace;
            file.minFilter = LinearFilter;
            file.magFilter = LinearFilter;
            file.generateMipmaps = true;
            
            const renderer = Renderer.getInstance().renderer;
            if (renderer) {
                file.anisotropy = renderer.capabilities.getMaxAnisotropy();
            }
            
            file.needsUpdate = true;
        }
        
        this.items[item.name] = file;
        this.loaded++;
        if (this.loaded === this.toLoad) {
            this.trigger('ready');
        }
    }
}
